<script lang="ts">
  export let name: string | undefined;
  export let required: boolean = false;
  export let id: string | undefined = undefined;
  export let hint: string | undefined = undefined;
  export let errorMessage: string | undefined = undefined;
  export let full: boolean = true;
  export let showOptionalIndicator: boolean = true;
</script>

<label class="block" for={id} on:click|stopPropagation|preventDefault class:w-full={full}>
  <!-- Header -->
  {#if name || errorMessage}
    <div class="mb-1 flex justify-between text-12 text-nxgray-600">
      {#if name}
        <span class="flex pl-0.5 text-gray-700">
          <span class="ml-px sm:flex-shrink-0">{name}</span>
          {#if required}
            <span class="text-danger-600 ml-1">*</span>
          {:else if showOptionalIndicator}
            <span class="ml-1 font-normal opacity-50">(optional)</span>
          {/if}
        </span>
      {/if}
      {#if errorMessage}
        <span class="text-danger-600 px-2">{errorMessage}</span>
      {/if}
    </div>
  {/if}
  {#if hint && hint.length}
    <div class="my-1 pl-0.5 text-12 font-normal text-brand-gray-70">{hint}</div>
  {/if}
  <slot />
</label>
